import React, { SyntheticEvent } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { HeaderCell } from 'src/features/CampaignMapping/components/atoms/HeaderCell';
import { CampaignSearch } from 'src/features/CampaignMapping/components/molecules/CampaignSearch';
import { SortDirection } from 'src/features/CampaignMapping/types';
import {
  CAMPAIGN_NAME_COL_WIDTH,
  PLATFORM_COL_WIDTH,
  ROW_HEIGHT,
} from 'src/features/CampaignMapping/utils/constants';

type Props = {
  cardBg: string;
  columns: string[];
  searchValue: string;
  onSearchChange: (v: string) => void;
  onSortToggle: () => void;
  sortOrder: SortDirection;
  headerScrollRef: React.RefObject<HTMLDivElement>;
  onHeaderScroll: (e: SyntheticEvent) => void;
};

export const HeaderRow: React.FC<Props> = ({
  cardBg,
  columns,
  searchValue,
  onSearchChange,
  onSortToggle,
  sortOrder,
  headerScrollRef,
  onHeaderScroll,
}) => {
  return (
    <Box
      position="sticky"
      top={0}
      zIndex={3}
      bg={cardBg}
      borderBottom="2px solid"
      borderColor="border.box"
      overflow="hidden">
      <Flex>
        <Box
          w={`${CAMPAIGN_NAME_COL_WIDTH}px`}
          h={`${ROW_HEIGHT}px`}
          bg="surface.control"
          display="flex"
          alignItems="center"
          px={2}
          position="sticky"
          left={0}
          zIndex={4}
          borderRight="1px solid"
          borderColor="border.layout"
          flexShrink={0}>
          <CampaignSearch
            searchValue={searchValue}
            onSearchChange={onSearchChange}
            onSortToggle={onSortToggle}
            sortOrder={sortOrder}
          />
        </Box>

        <Box
          ref={headerScrollRef}
          overflowX="scroll"
          sx={{
            '&::-webkit-scrollbar': {
              '-webkit-appearance': 'none',
              width: '2px',
              height: '6px',
            },
            '::-webkit-scrollbar-track': {
              background: 'gray.100',
              borderRadius: '2px',
            },
            '::-webkit-scrollbar-thumb': {
              background: 'gray.400',
              borderRadius: '2px',
            },
          }}
          onScroll={onHeaderScroll}
          flex={1}
          position="relative">
          <Flex>
            {columns.map((column) => (
              <Box
                key={column}
                w={`${PLATFORM_COL_WIDTH}px`}
                h={`${ROW_HEIGHT}px`}
                bg="surface.control"
                display="flex"
                alignItems="center"
                px={2}
                borderRight="1px solid"
                borderColor="border.layout"
                flexShrink={0}>
                <HeaderCell label={column} />
              </Box>
            ))}
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};
